import React from 'react';
import './card.css';

const Card = (props) => {
    return ( <>
    <div className={props.vendorCardStyle}>
        <img src={props.vendorLogo} alt={props.vendorDesc} />
    </div>
    </> );
}
 
export default Card;